import { useState } from 'react';
import {
    FormControl,
    FormLabel,
    Text,
    Box,
    FormErrorMessage,
    Stack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import { TextEditor } from '../../../../../components';
import TriggerFieldToolTip from './TriggerFieldToolTip';
import { useTriggerForm } from '../useTriggerForm.js';
import { FORM_FIELD_PATHS } from '../triggerFormConstants.js';
import { isJsonBodyInvalid } from '../triggerFormUtils.js';
import walkthroughIds from '../../walkthroughIds';
import {
    formLabelStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

// Custom Formik field component for TextEditor
const TextEditorField = ({
    field,
    form,
    setCursorPosition,
    editMode,
    formData,
    updateFormData,
    ...props
}) => {
    const handleBodyChange = (e) => {
        const newValue = e.target.value;
        updateFormData(FORM_FIELD_PATHS.BODY, newValue);
        form.setFieldValue(field.name, newValue);
    };

    return (
        <TextEditor
            {...props}
            id="body"
            field="body"
            setCursorPosition={setCursorPosition}
            textfield={{
                label: '',
                value: formData?.action?.body || '',
                onChange: handleBodyChange,
                onBlur: () => {
                    form.setFieldTouched(field.name, true);
                },
                maxH: '300px',
                overflowY: 'auto',
            }}
            dataWalkthroughId={editMode.ufBodyTextarea}
        />
    );
};

const WebhookBodyInput = ({
    darkMode,
    fields,
    setCursorPosition,
    errors,
    touched,
}) => {
    const { editMode } = walkthroughIds;
    const [isHovered, setIsHovered] = useState(false);

    // Use context instead of Redux
    const { formData, updateFormData } = useTriggerForm();

    return (
        <FormControl
            sx={{ margin: '0 !important', position: 'relative' }}
            isInvalid={!!errors?.body && touched?.body}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Box marginBottom={4}>
                <Box>
                    <FormLabel htmlFor="body" sx={formLabelStyling(darkMode)}>
                        JSON Body
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enter the JSON payload for the webhook request.
                    </Text>
                </Box>
                <Box paddingTop="15px">
                    <Stack direction="row" width="100%" minWidth="800px">
                        <Box width={733} minWidth={733}>
                            <Field
                                component={TextEditorField}
                                name="body"
                                darkMode={darkMode}
                                fields={fields}
                                setCursorPosition={setCursorPosition}
                                editMode={editMode}
                                formData={formData}
                                updateFormData={updateFormData}
                                validate={(value) =>
                                    isJsonBodyInvalid(value)
                                        ? 'Please enter valid JSON'
                                        : undefined
                                }
                            />
                        </Box>
                        <TriggerFieldToolTip
                            isVisible={isHovered}
                            label="Enter valid JSON that will be sent as the request body. Use the Fields selector to insert dynamic values that will be replaced when the webhook is triggered."
                            ariaLabel="webhook-body-tip"
                        />
                    </Stack>
                    {errors?.body && touched?.body && (
                        <FormErrorMessage>{errors.body}</FormErrorMessage>
                    )}
                </Box>
            </Box>
        </FormControl>
    );
};

export default WebhookBodyInput;
